var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExpertEnabled)?_c('router-link',{staticClass:"button is-primary",attrs:{"to":{ name: 'expert' }}},[_vm._v(" "+_vm._s(_vm.expertLabel)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }